import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Button } from './button';

export const SearchFilterInput = ({
    value,
    onChange,
    placeholder = 'Search',
    className = '',
    inputClassName = '',
}) => {
    return (
        <div
            className={`inline-flex items-center gap-2 bg-backgrounds-white border border-backgrounds-border rounded-lg px-3 h-7 text-sm text-texts-secondary300 transition-colors shadow-none hover:border-backgrounds-primary200 hover:shadow-sm focus-within:border-backgrounds-primary200 focus-within:shadow-inner ${className}`}
        >
            <FontAwesomeIcon
                icon={faSearch}
                className='text-sm text-texts-secondary300'
            />
            <input
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className={`flex-1 bg-transparent outline-none text-sm text-texts-secondary placeholder:text-texts-secondary300/70 ${inputClassName}`}
            />
            {value && (
                <div className='ml-1'>
                    <Button
                        icon={faTimes}
                        hoverText='Clear search'
                        className='!w-6 !h-6 !border-0 !bg-transparent text-texts-secondary300 hover:text-texts-secondary shadow-none hover:scale-100'
                        onClick={() =>
                            onChange && onChange({ target: { value: '' } })
                        }
                        type={'danger'}
                    />
                </div>
            )}
        </div>
    );
};
